import React from 'react';
import PayViaLinkFailureResult from '@/features/payment/presentation/components/PayViaLinkFailureResult';

export const PayViaLinkFailurePage: React.FC = () => {
  return <PayViaLinkFailureResult />;
};

export default PayViaLinkFailurePage;
